import {
  ITwoFactorEnableData,
  ITwoFactorSetupData,
  ITwoFactorVerifyData,
  ITwoFactorDisableData,
} from '@common/interfaces/auth'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import { ILoadingData } from '../types'
import * as actions from './actions'

const setupDataReducer = (
  state: ILoadingData<ITwoFactorSetupData> = {
    isLoading: false,
    isSaving: false,
    isSaved: false,
    data: {},
  },
  action: IAction<ITwoFactorSetupData>,
): ILoadingData<ITwoFactorSetupData> => {
  switch (action.type) {
    case actions.SETUP_TWO_FACTOR_REQUEST:
      return { ...state, isLoading: true }
    case actions.SETUP_TWO_FACTOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
      }
    case actions.SETUP_TWO_FACTOR_FAILURE:
      return {
        ...state,
        isLoading: false,
        data: {},
      }
    case actions.CLEAR_SETUP_DATA:
      return {
        isLoading: false,
        isSaving: false,
        isSaved: false,
        data: {},
      }
    default:
      return state
  }
}
const emptyState = {
  isLoading: false,
  isSaving: false,
  isSaved: false,
  data: null as never,
}

export default combineReducers({
  setupData: setupDataReducer,
  enableData: createLoadingDataReducer<ITwoFactorEnableData>(
    [actions.ENABLE_TWO_FACTOR_REQUEST],
    [actions.ENABLE_TWO_FACTOR_SUCCESS, actions.ENABLE_TWO_FACTOR_FAILURE],
    undefined,
    undefined,
    undefined,
    undefined,
    emptyState,
  ),
  verifyData: createLoadingDataReducer<ITwoFactorVerifyData>(
    [actions.VERIFY_TWO_FACTOR_REQUEST],
    [actions.VERIFY_TWO_FACTOR_SUCCESS, actions.VERIFY_TWO_FACTOR_FAILURE],
    undefined,
    undefined,
    undefined,
    undefined,
    emptyState,
  ),
  disableData: createLoadingDataReducer<ITwoFactorDisableData>(
    [actions.DISABLE_TWO_FACTOR_REQUEST],
    [actions.DISABLE_TWO_FACTOR_SUCCESS, actions.DISABLE_TWO_FACTOR_FAILURE],
    undefined,
    undefined,
    undefined,
    undefined,
    emptyState,
  ),
})
